import { createSlice } from "@reduxjs/toolkit";
import { logoutUser } from "@/src/redux/actions/authActions";
import { fetchCategoryChildrenList } from "@/src/redux/actions/baseDataActions";
import type { BaseDataState } from "@/src/types/category.types";
import { forceLogout } from "@/src/redux/slices/authSlice";

const initialState: BaseDataState = {
  categoryChildren: [],
  fetchedForUserId: null,
  loadedAt: null,
  loading: false,
  error: null,
};

const baseDataSlice = createSlice({
  name: "baseData",
  initialState,
  reducers: {
    clearBaseData(state) {
      state.categoryChildren = [];
      state.fetchedForUserId = null;
      state.loadedAt = null;
      state.loading = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCategoryChildrenList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCategoryChildrenList.fulfilled, (state, action) => {
        state.loading = false;
        state.categoryChildren = action.payload.categoryChildren;
        state.fetchedForUserId = action.payload.userId;
        state.loadedAt = new Date().toISOString();
        state.error = null;
      })
      .addCase(fetchCategoryChildrenList.rejected, (state, action) => {
        state.loading = false;
        state.error = (action.payload as string) ?? "Failed to load categories";
      })
      .addCase(logoutUser.fulfilled, (state) => {
        Object.assign(state, initialState);
      })
      .addCase(forceLogout, (state) => {
        Object.assign(state, initialState);
      });
  },
});

export const { clearBaseData } = baseDataSlice.actions;
export const baseDataReducer = baseDataSlice.reducer;
